import { render, staticRenderFns } from "./TpcPrivacy.vue?vue&type=template&id=12c8bbfd&scoped=true"
import script from "./TpcPrivacy.vue?vue&type=script&lang=js"
export * from "./TpcPrivacy.vue?vue&type=script&lang=js"
import style0 from "./TpcPrivacy.vue?vue&type=style&index=0&id=12c8bbfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c8bbfd",
  null
  
)

export default component.exports